import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Action = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Action' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,23 L4,20 L1,23 Z M20,4 L23,1 L20,4 Z M9,11 L12,8 L9,11 Z M13,15 L16,12 L13,15 Z M10,5 L19,14 L20,13 C22,11 24.0533047,8.00000006 20,4 C15.9466953,-5.91784286e-08 13,2 11,4 L10,5 Z M4,11 L5,10 L14,19 L13,20 C11.0000005,22 7.9999999,24.0873857 4,20 C9.84858655e-08,15.9126143 2,13 4,11 Z' />
  </StyledIcon>
);
